// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c7b1aa2","239":"45f75067","732":"045db1d5"}[chunkId] + ".chunk.js";
};